import { useCallback } from 'react';
import { useAnalytics } from '../context/AnalyticsContext';

/**
 * Koleksiyon etkileşim takibi için custom hook (JSONB Format)
 * Koleksiyon görüntüleme ve tıklama etkileşimlerini takip eder
 */
export const useCollectionTracking = () => {
  const { trackCollectionInteraction } = useAnalytics();

  // Koleksiyon görüntüleme takip et
  const trackCollectionView = useCallback((collection) => {
    if (!collection || !collection.id) return;

    trackCollectionInteraction(
      collection.id,
      'view',
      collection.name,
      collection.description,
      collection.image,
      collection.url || `/collection/${collection.id}`,
      collection.product_count,
      {
        category: collection.category,
        featured: collection.featured,
        created_at: collection.created_at
      }
    );
  }, [trackCollectionInteraction]);

  // Koleksiyon tıklama takip et
  const trackCollectionClick = useCallback((collection) => {
    if (!collection || !collection.id) return;

    trackCollectionInteraction(
      collection.id,
      'click',
      collection.name,
      collection.description,
      collection.image,
      collection.url || `/collection/${collection.id}`,
      collection.product_count,
      {
        category: collection.category,
        featured: collection.featured,
        created_at: collection.created_at
      }
    );
  }, [trackCollectionInteraction]);

  return {
    trackCollectionView,
    trackCollectionClick
  };
};

export default useCollectionTracking;